<template>
    <transition name="fade">
        <div v-if="getLoading"
             class="loading">
            <img src="../assets/loading.gif"
                 alt="載入中">
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters(['getLoading']),
    },
}

</script>

<style lang="scss">
@import '../style/variable.scss';
.loading {
    background: rgba(0, 0, 0, .5);
}
</style>



// WEBPACK FOOTER //
// com-loading.vue?260420ed